import { useLocation } from 'react-router-dom';
import CustomPdfViewer from './CustomPdfViewer';
import './PdfViewer.scss'

const PdfViewer = () => {
    const { state } = useLocation();
    const { pdfPath } = state || {};

    return (
        <div className='pdf-viewer-container'>
            <CustomPdfViewer pdfPath={pdfPath}/>
        </div>
    );
};

export default PdfViewer;
